(function () {
  const STORAGE_KEY = 'allure_first_touch';
  const TTL_MS = 30 * 24 * 60 * 60 * 1000;
  const ATTR_KEYS = [
    '_traffic_source',
    '_traffic_medium',
    '_utm_campaign',
    '_utm_content',
    '_utm_term',
    '_landing_page',
    '_referrer',
    '_first_visit',
  ];

  function readStored() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || !parsed.data || !parsed.savedAt) return null;
      if (Date.now() - parsed.savedAt > TTL_MS) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return parsed.data;
    } catch (e) {
      return null;
    }
  }

  function writeStored(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ savedAt: Date.now(), data }));
    } catch (e) {}
  }

  function getQueryParams() {
    return new URLSearchParams(window.location.search);
  }

  function externalReferrer() {
    const referrer = document.referrer;
    if (!referrer) return '';
    try {
      const ref = new URL(referrer);
      if (ref.hostname === window.location.hostname) return '';
      return referrer;
    } catch (e) {
      return '';
    }
  }

  function referrerSource(referrer) {
    if (!referrer) return '';
    try {
      return new URL(referrer).hostname.replace(/^www\./, '');
    } catch (e) {
      return '';
    }
  }

  function captureFirstTouch() {
    const existing = readStored();
    if (existing) return existing;

    const params = getQueryParams();
    const utmSource = params.get('utm_source');
    const utmMedium = params.get('utm_medium');
    const utmCampaign = params.get('utm_campaign');
    const utmContent = params.get('utm_content');
    const utmTerm = params.get('utm_term');
    const gclid = params.get('gclid');
    const fbclid = params.get('fbclid');
    const msclkid = params.get('msclkid');
    const referrer = externalReferrer();

    let source = utmSource || '';
    let medium = utmMedium || '';

    if (!source) {
      if (gclid) {
        source = 'google';
        medium = medium || 'cpc';
      } else if (fbclid) {
        source = 'facebook';
        medium = medium || 'paid';
      } else if (msclkid) {
        source = 'bing';
        medium = medium || 'cpc';
      } else if (referrer) {
        source = referrerSource(referrer);
        medium = medium || 'referral';
      } else {
        source = 'direct';
        medium = medium || 'none';
      }
    }

    const data = {
      _traffic_source: source,
      _traffic_medium: medium,
      _utm_campaign: utmCampaign || '',
      _utm_content: utmContent || '',
      _utm_term: utmTerm || '',
      _landing_page: window.location.pathname + window.location.search,
      _referrer: referrer,
      _first_visit: new Date().toISOString().slice(0, 10),
    };

    writeStored(data);
    return data;
  }

  let syncPromise = null;

  function syncToCart(attributes) {
    if (!window.routes || !window.routes.cart_update_url) return Promise.resolve();

    const payload = {};
    ATTR_KEYS.forEach((key) => {
      if (attributes[key]) payload[key] = attributes[key];
    });

    if (!Object.keys(payload).length) return Promise.resolve();

    if (syncPromise) return syncPromise;

    syncPromise = fetch(window.routes.cart_update_url, {
      ...fetchConfig(),
      body: JSON.stringify({ attributes: payload }),
    })
      .catch(() => {})
      .finally(() => {
        syncPromise = null;
      });

    return syncPromise;
  }

  function init() {
    const attribution = captureFirstTouch();
    syncToCart(attribution);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        syncToCart(attribution);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
